import ProductTypes from "../../components/ProductTypes";

export default function ProductTypesScreen(){
return <ProductTypes />
}